<template>
  <div class="main">
    <div class="loading">데이터를 불러오는 중입니다</div>
  </div>
  <!-- <div class="lds-facebook" v-if="loading">
    <div></div>
    <div></div>
    <div></div>
  </div> -->
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  /* left: 0px;
  top: 0px;
  width: 1920px;
  height: 1080px; */
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 9999;
}
.loading {
  position: relative;
  width: 360px;
  height: 60px;
  font-size: 26px;
  color: rgb(200, 200, 200);
  line-height: 60px;
  background-color: rgba(0, 0, 0, 0.6);
  filter: brightness(1.75);
  border-radius: 0.4em;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.lds-facebook {
  display: inline-block;
  position: absolute;
  width: 64px;
  height: 64px;
  top: 47%;
  left: 47%;
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 6px;
  width: 13px;
  background: #42b883;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds-facebook div:nth-child(1) {
  left: 6px;
  animation-delay: -0.24s;
}
.lds-facebook div:nth-child(2) {
  left: 26px;
  animation-delay: -0.12s;
}
.lds-facebook div:nth-child(3) {
  left: 45px;
  animation-delay: 0;
}
@keyframes lds-facebook {
  0% {
    top: 6px;
    height: 51px;
  }
  50%,
  100% {
    top: 19px;
    height: 26px;
  }
}

@media all and (min-width:0px) and (max-width:1280px){ 
  .main {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: 100vh;
    text-align: center;
    z-index: 9999;
  }
}
</style>